import { useEffect, useState, useContext } from "react";
import { Switch, useHistory, useRouteMatch } from "react-router-dom/cjs/react-router-dom";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom";

import { RouterBreadcrumbs } from "./RouterBreadCrumbs";
import { SPOCProfileHeader } from "./AddSPOCProfile/SPOCProfileHeader";
import { SPOCProfileForm } from "./AddSPOCProfile/SPOCProfileForm";

import { BackdropLoader } from "../DoctorMangement/BackdropLoader";
import { ToastEmitter } from "../DoctorMangement/ToastEmitter";
import { SOME_THING_WENT_WRONG } from "../DoctorMangement/constant"
import { getUserDetails } from "./Helper/API"
import { UnauthorizedRBAC } from "./UnauthorizedRBAC";
import { checkFeatureFeasbility } from "../../helper/utils";
import { FEATURE_NAME } from "../DoctorMangement/constant";
import { getFeaturesForUser } from "./Helper/utils";
import UserFeaturesContext  from '../../hook/UserDetails/UserFeaturesContext'; // Import the context

export const AddEditSpoc = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingUserFeature, setIsLoadingUserFeature] = useState(false);
    let { path } = useRouteMatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('id');
    const userName = queryParams.get('userName');
    const [SPOCProfileDetails, setSPOCProfileDetails] = useState();
    const { userFeatures, saveUserFeatures } = useContext(UserFeaturesContext);

    const fetchSPOCProfileDetails = async (userId) => {
        try {
            setIsLoading(true);
            let data = {
                userId: parseInt(userId, 10),
                userName: userName
            }
            const resp = await getUserDetails(data);
            setSPOCProfileDetails(resp);
            setIsLoading(false);
        }
        catch (err) {
            ToastEmitter(SOME_THING_WENT_WRONG, 'error');
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!localStorage.getItem("access_token")) {
            history.push('/login')
        }

        if (userId != 'undefined') {
            fetchSPOCProfileDetails(userId);
        }
    }, [])

    useEffect(() => {
        const saveUserFeaturesInContextHook = async () => {
          if (userFeatures) return;
          setIsLoadingUserFeature(true);
          const {userFeature, userRoles} = await getFeaturesForUser(history)
          saveUserFeatures(userFeature, userRoles);
          setIsLoadingUserFeature(false);
    
        }
        saveUserFeaturesInContextHook();
      }, []);

    return (
        <div className="bg-[#ffffff]">
            {
                (isLoading || isLoadingUserFeature) ? <BackdropLoader isLoading={isLoading || isLoadingUserFeature} /> :
                    <div className="flex flex-col px-8 py-4">
                        <nav className="flex flex-col">
                            <RouterBreadcrumbs />
                            {<SPOCProfileHeader SPOCProfileDetails={SPOCProfileDetails} />}
                        </nav>
                        <Switch>
                            <Route exact path={`${path}`}
                                render={() => {
                                    return checkFeatureFeasbility(FEATURE_NAME.CREATE_SPOC, userFeatures) ?
                                        <SPOCProfileForm setSPOCProfileDetails={setSPOCProfileDetails} SPOCProfileDetails={SPOCProfileDetails} />
                                        : <UnauthorizedRBAC />
                                }} />
                        </Switch>
                    </div>
            }

        </div>
    )
}
